export interface UserAuthentication {
    id: string;
    userAccountId: string;
    schoolAccountId: string;
    token: string;
    type: AuthenticationType; 
    e164phoneNumber: string;
    emailAddress: string;
    isAdmin: boolean;
    loggingHistories: LoggingHistory[]; // 10 last logins
    creationDatetime: Date; 
    lastModifiedDatetime: Date; 
}

export interface LoggingHistory {
    id: string;
    userAccountId: string;
    status: LoggingStatus; 
    failureReason: string;
    origin: LoggingOrigin; 
    creationDatetime: Date;
    lastModifiedDatetime: Date; 
}

export interface UserToken {
    token: string;
    userAccountId: string;
    schoolAccountId: string;
}

export enum AuthenticationType {
    PHONE = "PHONE",
    EMAIL = "EMAIL"
}

export enum LoggingStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED"
}

export enum LoggingOrigin {
    AUTO_LOGIN = "AUTO_LOGIN",
    REQUEST_LOGIN = "REQUEST_LOGIN",
    VALIDATE_LOGIN = "VALIDATE_LOGIN",
}

export enum RequestOrigin {
    BROWSER = "BROWSER",
    MOBILE = "MOBILE"
}

export enum AppUserType {
    SCHOOL = "SCHOOL",
    FAMILY = "FAMILY"
}